import * as types from './mutation-types'

const state = {
  modals: {
    category: {
      open: false,
      category: false,
    },
    archivePost: {
      open: false,
      post: false,
    },
    archiveReply: {
      open: false,
      reply: false,
    },
  },
  categories: {
    data: [],
    meta: {},
  },
  archivedCategories: {
    data: [],
    meta: {},
  },
  category: false,
  posts: {
    data: [],
    meta: {},
  },
  archivedPosts: {
    data: [],
    meta: {},
  },
  post: {},
  replies: {
    data: [],
    meta: {},
  },
  reply: false,
}

const mutations = {
  [types.DISCUSSION_CATEGORY_MODAL_OPEN](state, category = null) {
    state.modals.category.open = true
    state.modals.category.category = category
  },
  [types.DISCUSSION_CATEGORY_MODAL_CLOSE](state) {
    state.modals.category.open = false
    state.modals.category.category = false
  },
  [types.DISCUSSION_ARCHIVE_POST_MODAL_OPEN](state, post) {
    state.modals.archivePost.open = true
    state.modals.archivePost.post = post
  },
  [types.DISCUSSION_ARCHIVE_POST_MODAL_CLOSE](state) {
    state.modals.archivePost.open = false
    state.modals.archivePost.post = false
  },
  [types.DISCUSSION_ARCHIVE_REPLY_MODAL_OPEN](state, reply) {
    state.modals.archiveReply.open = true
    state.modals.archiveReply.reply = reply
  },
  [types.DISCUSSION_ARCHIVE_REPLY_MODAL_CLOSE](state) {
    state.modals.archiveReply.open = false
    state.modals.archiveReply.reply = false
  },

  /**
   * Categories
   */
  [types.DISCUSSION_SET_CATEGORIES](state, categories) {
    state.categories = categories
  },
  [types.DISCUSSION_SET_CATEGORY](state, category) {
    state.category = _.extend({}, state.category, category)

    // Find index of category in list of categories
    let index = _.findIndex(state.categories.data, function (stateCategory) {
      return stateCategory.uuid === category.uuid
    })

    if (index >= 0) {
      // Update category
      state.categories.data.splice(index, 1, category)
    }
  },
  [types.DISCUSSION_ADD_CATEGORY](state, category) {
    state.categories.data.push(category)
  },
  [types.DISCUSSION_REMOVE_CATEGORY](state, categoryUuid) {
    // Find index of category in list of categories
    let index = _.findIndex(state.categories.data, function (category) {
      return category.uuid === categoryUuid
    })

    if (index >= 0) {
      // Remove it from list
      state.categories.data.splice(index, 1)
    }

    // Check if active category is category being remove.
    if (_.isObject(state.category)) {
      if (state.category.uuid === categoryUuid) {
        // Unset it if so.
        state.category = false
      }
    }
  },
  /**
   * Posts
   */
  [types.DISCUSSION_SET_POSTS](state, posts) {
    state.posts = posts
  },
  [types.DISCUSSION_SET_ARCHIVED_POSTS](state, posts) {
    state.archivedPosts = posts
  },
  [types.DISCUSSION_SET_POST](state, post) {
    state.post = _.extend({}, state.post, post)
  },
  [types.DISCUSSION_ADD_POST](state, post) {
    state.posts.data.unshift(post)
  },
  [types.DISCUSSION_REMOVE_POST](state, postUuid) {
    // Find index of post in list of posts
    let index = _.findIndex(state.posts.data, function (post) {
      return post.uuid === postUuid
    })

    if (index >= 0) {
      // Remove it from list
      state.posts.data.splice(index, 1)
    }

    // Check if active post is post being removed.
    if (_.isObject(state.post)) {
      if (state.post.uuid === postUuid) {
        // Unset it if so.
        state.post = false
      }
    }
  },
  /**
   * Replies
   */
  [types.DISCUSSION_SET_REPLIES](state, replies) {
    state.replies = replies
  },
  [types.DISCUSSION_SET_REPLY](state, reply) {
    // Find index of reply in list of replies
    let index = _.findIndex(state.replies.data, function (item) {
      return item.uuid === reply.uuid
    })

    if (index >= 0) {
      // Replace it in list
      state.replies.data.splice(index, 1, reply)
    }
  },
  [types.DISCUSSION_ADD_REPLY](state, reply) {
    state.replies.data.push(reply)
  },
  [types.DISCUSSION_REMOVE_REPLY](state, replyUuid) {
    // Find index of reply in list of replies
    let index = _.findIndex(state.replies.data, function (reply) {
      return reply.uuid === replyUuid
    })

    if (index >= 0) {
      // Remove it from list
      state.replies.data.splice(index, 1)
    }

    // Check if active reply is reply being removed.
    if (_.isObject(state.reply)) {
      if (state.reply.uuid === replyUuid) {
        // Unset it if so.
        state.reply = false
      }
    }
  },
}

export default {
  state,
  mutations,
}